import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LanguageSettings } from './language-settings';
import { UserSettings as TwoFaUserSettings } from '../auth/two-fa/user-settings';
import styles from './styles.module.scss';
export var UserSettings = function (_a) {
    var showTwoFaSettings = _a.showTwoFaSettings, showLanguageSettings = _a.showLanguageSettings;
    return (_jsxs("div", { className: "".concat(styles.container, " u-mb-avoid-floating-buttons"), children: [showTwoFaSettings && _jsx(TwoFaUserSettings, {}), showLanguageSettings && _jsx(LanguageSettings, {})] }));
};
